// Copilot: Create a TanStack Query hook. Strong types for input/output.
// Set staleTime, select shape, error normalization to ApiResponse.
// No UI code; export the hook only.

import { useMutation } from '@tanstack/react-query'
import type { AxiosError } from 'axios'
import { registerUser } from '@/utils/api/user-service'
import { SignUpRequestAllowedApps, type ApiResponse, type SignUpRequest } from '@/utils/api/user-service/models'
import { handleError } from '@/lib/utils'

export type SignUpInput = Pick<SignUpRequest, 'firstName' | 'lastName' | 'email' | 'password'> & {
  // Local-only fields (not sent): confirmPassword, acceptTerms handled by form schema
}

export type SignUpError = AxiosError<ApiResponse>

export function useSignUp() {
  return useMutation<Awaited<ReturnType<typeof registerUser>>, SignUpError, SignUpInput>({
    mutationKey: ['sign-up'],
    mutationFn: async (input: SignUpInput) => {
      // The orval-generated function expects a SignUpRequest body
      const body: SignUpRequest = {
        firstName: input.firstName,
        lastName: input.lastName,
        email: input.email,
        password: input.password,
        allowedApps: [SignUpRequestAllowedApps.MEMBERSHIP_PORTAL],
      }
      return registerUser(body)
    },
    onError: error => handleError(error, 'Sign Up failed'),
  })
}
